import React, { PropsWithChildren, FC } from 'react';
import {
  ErrorBoundary as SentryErrorBoundary,
  FallbackRender,
} from '@sentry/react';

export type ErrorFallbackProps = React.ReactElement | FallbackRender;

type Props = PropsWithChildren<{
  FallbackComponent: ErrorFallbackProps;
}>;

const ErrorBoundary: FC<Props> = ({ children, FallbackComponent }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const Component = SentryErrorBoundary as any; // is necessary because of the npm hoisting behavior causing type mismatch
  return <Component fallback={FallbackComponent}>{children}</Component>;
};

export default ErrorBoundary;
